(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputWysiwyg', cpInputWysiwyg);

    cpInputWysiwyg.$inject = ['summernoteImageSrvc', 'notificationSrvc', 'summernoteFileMessagesConst'];

    function cpInputWysiwyg(summernoteImageSrvc, notificationSrvc, summernoteFileMessagesConst) {

        InputWysiwygController.$inject = ['$scope', '$element'];

        function InputWysiwygController($scope, $element) {
            var self = this;

            self.options = {
                height: 200,
                focus: true,
                codemirror: { // codemirror options
                    theme: 'monokai'
                },
                    
                callbacks: {
                    onImageUpload: function(image) {
                        var $summernote = angular.element($element).find('.summernote');
                        summernoteImageSrvc.uploadImage(image[0]).$promise.then(function(response){
                            var img = document.createElement('img'); 
                            img.src = response.file;
                            img.setAttribute('data-id', response.pk);
                            $summernote.summernote('insertNode', img);
                            notificationSrvc.notification("success", summernoteFileMessagesConst.add);
                        }, function(error) {
                            notificationSrvc.notification("error", summernoteFileMessagesConst.error);
                        });
                    },
                    onMediaDelete : function(target) {
                        var id = target[0].getAttribute('data-id');
                        if(!id) return;

                        summernoteImageSrvc.deleteImage(id).$promise.then(function(response){
                            notificationSrvc.notification("success", summernoteFileMessagesConst.delete);
                        }, function(error) {
                            notificationSrvc.notification("error", summernoteFileMessagesConst.error);
                        });
                    }
                }
            };
        }

        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-wysiwyg/input-wysiwyg.html',
            controller: InputWysiwygController,
            controllerAs: 'dctrl',
            scope: {
                title: '@',
                labelClass: '@?',
                containerClass: '@',
                fullWidth: '@',
                object: '=',
                prop: '@',
                onChange: '&?',
                isRequired: '=?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                function isWithLabel() {
                    return scope.fullWidth === undefined ? true : scope.withLabel;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
